import Modal from '../../../../components/Modal';
import PropTypes from 'prop-types';

const LessonModal = ({ description, isOpen, onClose, value }) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose} titleName={'Lesson : ' + description} contentWidth="50%">
      <div className="lesson-view" dangerouslySetInnerHTML={{ __html: value }}></div>
    </Modal>
  );
};
  
LessonModal.propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  value: PropTypes.string,
  description: PropTypes.string
};

export default LessonModal;